<script setup>
    import FormularioVerificacionCorreo from '../../components/formularioVerificacionCorreo.vue';
</script>
<template>
    <FormularioVerificacionCorreo urlSiguiente="/cliente/verificar-telefono"/>
</template>